import { TIER_LABELS } from '../config/labels';

interface TierBadgeProps {
  tier?: string | null;
  size?: 'sm' | 'md' | 'lg';
}

const TIER_STYLES: Record<string, string> = {
  STANDARD: 'bg-green-100 text-green-700 border-green-300',
  ENHANCED_REVIEW: 'bg-amber-100 text-amber-700 border-amber-300',
  ESCALATE: 'bg-red-600 text-white border-red-600',
};

const SIZE_STYLES: Record<string, string> = {
  sm: 'text-xs px-2 py-0.5',
  md: 'text-sm px-2.5 py-1',
  lg: 'text-base px-3 py-1.5',
};

export default function TierBadge({ tier, size = 'md' }: TierBadgeProps) {
  if (!tier) return null;
  const tierUpper = tier.toUpperCase();
  const label = TIER_LABELS[tierUpper] || tier;
  const style = TIER_STYLES[tierUpper] || 'bg-slate-100 text-slate-700 border-slate-300';
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border font-medium ${style} ${SIZE_STYLES[size]}`}
    >
      {label}
    </span>
  );
}